import { deleteDoc, doc } from 'firebase/firestore';
import { removePushNotificationTokenDate } from 'shared/services/local-storage';

import {
  CollectionOptions,
  getCollection,
  getUidByPushNotificationToken,
  removePushNotificationToken,
} from './helpers';

export const deletePushToken = async (token: string) => {
  const tokenDoc = doc(getCollection(CollectionOptions.FcmTokens), token);
  deleteDoc(tokenDoc);

  // clear token from local storage
  const uid = getUidByPushNotificationToken(token);
  if (!uid) {
    return;
  }
  removePushNotificationToken(uid);
  removePushNotificationTokenDate(uid);
};
